import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettPsMergeForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_same_item = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txPsToKeep = React.useRef(null);
  const rf_txPsToDelete = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txPsToKeep.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txPsToKeep.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txPsToDelete.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txPsToDelete.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txPsToKeep.current.getKey()===rf_txPsToDelete.current.getKey()) {
      r_snack_same_item.current.setOpen(true);
      return;
    }
    
    let inPs_toKeep = rf_txPsToKeep.current.getKey();
    let inPs_toDelete = rf_txPsToDelete.current.getKey();

    let record = {};
    record['inPs_toKeep'] = inPs_toKeep;
    record['inPs_toDelete'] = inPs_toDelete;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/ps/merge/do`, record)]).then((result) => {
      rf_txPsToKeep.current.clear();
      rf_txPsToDelete.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.merge_x', 'field.pss')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.merge_duplicates')} />
          </div>
        }
      >

      <CxSearcher xref={rf_txPsToKeep}
        label={trans('field.keep')}
        url="pss" 
        col_id="inPs" 
        col_tx="txPs"
        tooltip={`${trans('field.ps')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "inPs", show: false },
          { id: "1", Header: trans('field.ps'), accessor: row => rf_txPsToKeep.current.getTable().highlightText(row["txPs"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      <CxSearcher xref={rf_txPsToDelete}
        label={trans('field.delete')}
        url="pss" 
        col_id="inPs" 
        col_tx="txPs"
        tooltip={`${trans('field.ps')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "inPs", show: false },
          { id: "1", Header: trans('field.ps'), accessor: row => rf_txPsToDelete.current.getTable().highlightText(row["txPs"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_same_item} severity="error" value={trans('msg.same_item')} />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettPsMergeForm;
